export const servicePages = [
  {
    path: "/bursa-klasik-masaj",
    crumb: "Klasik Masaj Bursa",
    title: "Klasik Masaj Bursa | Lavenza Nilüfer",
    description: "Bursa klasik masaj: İsveç tekniğine dayanan akıcı hareketlerle tüm vücut rahatlaması. Kime uygun, seans nasıl ilerler? Lavenza Nilüfer Konak'ta WhatsApp randevu.",
    eyebrow: "Hizmet · Klasik Masaj",
    accent: "Bursa",
    h1: "Klasik Masaj",
    image: "/images/bursa-klasik-masaj.webp",
    imageAlt: "Klasik masaj için hazırlanan yağ ve havlular",
    service: "Klasik Masaj",
    intro: "Klasik masaj, dünyada en yaygın uygulanan ve en çok tanınan masaj türüdür. Bursa'da klasik masaj arayan misafirlerimiz için Lavenza, İsveç tekniğinin temel hareketlerini sakin bir ortamda, kişiye göre ayarlanan baskıyla uygular.",
    sections: [
      {
        h2: "Klasik Masaj Nedir?",
        paragraphs: [
          "Kökleri 19. yüzyıl İsveç'ine dayanan bu teknik, beş temel hareket üzerine kuruludur: uzun sıvazlama (effleurage), yoğurma (petrissage), sürtünme, ritmik vuruş ve titreşim. Hareketler kalbe doğru yönlendirilir ve genellikle ılık bir masaj yağıyla uygulanır. Amaç, kasların yumuşamasını ve bedenin genel olarak gevşemesini desteklemektir. Klasik masaj Bursa'da olduğu gibi dünyanın her yerinde \"ilk masaj\" için en çok önerilen türdür.",
        ],
      },
      {
        h2: "Kimler Tercih Ediyor?",
        paragraphs: [
          "Belirli bir şikâyeti olmayan ama yoğun bir dönemden çıkan kişiler, uyku düzeni bozulanlar, uzun yolculuk sonrası tutulma hissedenler ve masaja yeni başlayanlar klasik masajı seçiyor. Orta şiddette baskı çoğu kişi için rahat gelir; daha hafif ya da daha güçlü isteyenler için seans içinde ayar yapılır.",
        ],
        list: [
          "Genel yorgunluk ve gerginlik",
          "Uzun yolculuk veya seyahat sonrası",
          "Uyku kalitesini destekleme isteği",
          "Masajla ilk tanışma",
        ],
      },
      {
        h2: "Lavenza'da Klasik Masaj Seansı Nasıl İlerler?",
        paragraphs: [
          "Kısa bir tercih görüşmesinin ardından odanızda hazırlanmanız için size süre verilir. Uygulama genellikle sırttan başlar; omuz ve boyun, ardından bacaklar ve kollar çalışılır. Yüz üstü ve sırt üstü olmak üzere iki pozisyonda ilerlenir. Yalnızca çalışılan bölge açıkta kalır. Seans boyunca baskı hakkında geri bildirim vermeniz beklenir; sessiz kalmayı tercih ediyorsanız bu da tamamen normaldir.",
        ],
      },
      {
        h2: "Klasik Masaj ile Diğer Uygulamalar Arasındaki Fark",
        paragraphs: [
          "Soft masajdan daha belirgin bir baskıya sahiptir ama medikal masaj kadar bölgesel değildir. Tüm vücuda eşit dikkat verilir. Eğer boyun ya da belde odaklanılması gereken belirgin bir yoğunluk varsa medikal masaj daha uygun olabilir; sadece hafif dokunuş istiyorsanız soft masaj tercih edilir. Kese ve köpükle birleştirildiğinde klasik masaj, Bursa spa ritüelinin doğal tamamlayıcısıdır.",
        ],
      },
      {
        h2: "Seans Sonrası Öneriler",
        paragraphs: [
          "Bol su için, o gün ağır egzersizden kaçının ve mümkünse erken dinlenin. Kaslarda birkaç saat hafif bir hassasiyet hissedilebilir; bu geçicidir. Klasik masajı düzenli hale getirmek isteyen misafirlerimiz genellikle ayda bir ya da iki kez randevu alıyor.",
        ],
      },
      {
        h2: "Nilüfer'de Klasik Masaj İçin Randevu",
        paragraphs: [
          "Salonumuz Nilüfer Konak Mahallesi'nde, Kurşunlu Sokak üzerinde. Klasik masaj Nilüfer'de arayan misafirlerimiz WhatsApp'tan yazarak dakikalar içinde randevu oluşturabilir. Diğer uygulamalarımızı masaj hizmetleri sayfasında, tür seçimi hakkında ayrıntılı bilgiyi Bursa masaj rehberinde bulabilirsiniz.",
          "Randevu mesajınızda tercih ettiğiniz baskı seviyesini (hafif, orta, güçlü) ve varsa özellikle çalışılmasını istediğiniz bölgeyi yazmanız, seansın ilk dakikasından itibaren size uygun ilerlemesini sağlar. Bilgi vermeseniz de sorun değil; her şey odada konuşulur.",
        ],
      },
      {
        h2: "Beş Temel Hareket Yakından",
        paragraphs: [
          "Effleurage, yani uzun sıvazlama, seansın hem başında hem sonunda kullanılır; yağı yayar, bedeni dokunuşa alıştırır ve dolaşımı yönlendirir. Petrissage adı verilen yoğurma hareketleri kas dokusunu kaldırıp bırakarak derinlemesine çalışır; sırt ve bacaklarda en çok hissedilen aşamadır. Sürtünme hareketleri daha küçük ve daireseldir, gergin noktaların çevresinde uygulanır.",
          "Ritmik vuruşlar hafif ve hızlıdır, kasları uyandırır; herkes sevmez, bu yüzden isteğe bağlı tutarız. Titreşim ise seansın sonunda bedeni yumuşak bir şekilde sakinleştirir. Bu beş hareketin sırası ve yoğunluğu, seans öncesi görüşmede söylediklerinize göre ayarlanır.",
        ],
        list: [
          "Sıvazlama: başlangıç ve bitiş",
          "Yoğurma: derin kas çalışması",
          "Sürtünme: noktasal gerginlikler",
          "Vuruş ve titreşim: uyandırma ve sakinleştirme",
        ],
      },
    ],
    related: [
      { label: "Medikal Masaj Bursa", path: "/bursa-medikal-masaj" },
      { label: "Soft Masaj Bursa", path: "/bursa-soft-masaj" },
      { label: "Bursa Masaj Rehberi", path: "/bursa-masaj" },
      { label: "Bursa Spa", path: "/bursa-spa" },
      { label: "Masaj Hizmetleri", path: "/masaj-hizmetleri" },
    ],
    faq: [
      { q: "Klasik masaj ile İsveç masajı aynı şey mi?", a: "Evet, Türkiye'de klasik masaj olarak bilinen uygulama İsveç masajı tekniğine dayanır. Aynı temel hareketler kullanılır." },
      { q: "Klasik masajda yağ kullanılıyor mu?", a: "Evet, hareketlerin akıcı olması için cilt dostu masaj yağı kullanılır. Alerjiniz varsa seans öncesinde lütfen belirtin." },
      { q: "Klasik masaj sırasında tamamen soyunmam gerekir mi?", a: "İç çamaşırınız üzerinizde kalır ve havluyla örtülürsünüz. Yalnızca o an çalışılan bölge açılır." },
      { q: "Klasik masajı ne kadar sürede tekrar yaptırabilirim?", a: "Bir engel yoktur; birçok misafirimiz iki üç haftada bir tercih ediyor. Süre ve fiyat bilgisi için WhatsApp'tan yazabilirsiniz." },
      { q: "Klasik masaj sonrası araç kullanabilir miyim?", a: "Evet, ancak birkaç dakika dinlenip yavaşça kalkmanızı ve bol su içmenizi öneririz. Seans sonrası hafif bir uyku hali normaldir; direksiyona geçmeden önce kendinizi tamamen uyanık hissettiğinizden emin olun." },
    ],
  },
  {
    path: "/bursa-medikal-masaj",
    crumb: "Medikal Masaj Bursa",
    title: "Medikal Masaj Bursa | Lavenza Nilüfer",
    description: "Bursa medikal masaj: boyun, sırt ve belde biriken gerginliğe odaklanan hedefli uygulama. Masa başı yorgunluğu için kime uygun? Lavenza Nilüfer, WhatsApp randevu.",
    eyebrow: "Hizmet · Medikal Masaj",
    accent: "Bursa",
    h1: "Medikal Masaj",
    image: "/images/bursa-medikal-masaj.webp",
    imageAlt: "Medikal masaj uygulama odası ve masaj masası",
    service: "Medikal Masaj",
    intro: "Uzun saatler ekran karşısında oturmak, telefona eğilmek ve tek pozisyonda kalmak boyun, omuz ve belde belirli noktalarda birikir. Medikal masaj, işte bu noktalara yoğunlaşan hedefli bir uygulamadır. Lavenza Nilüfer'de medikal masajı, sağlık iddiası taşımayan dürüst bir dille sunuyoruz.",
    sections: [
      {
        h2: "Medikal Masaj Nedir, Ne Değildir?",
        paragraphs: [
          "Medikal masaj, klasik masajdan farklı olarak tüm vücuda eşit dikkat vermez; gerginliğin toplandığı bölgeye odaklanır ve daha yavaş, daha derin çalışır. Adındaki \"medikal\" sözcüğü tıbbi bir tedavi olduğu anlamına gelmez. Masaj hastalık tedavi etmez, tanı koymaz ve hekim muayenesinin yerini almaz. Yapabileceği şey, kas gerginliğinin hafiflemesine ve rahatlamaya yardımcı olmaktır.",
        ],
      },
      {
        h2: "Kimler İçin Düşünülebilir?",
        paragraphs: [
          "Masa başında çalışan ve gün sonunda boynunu döndürmekte zorlananlar, omuzlarını sürekli yukarıda taşıyanlar, uzun süre araç kullananlar ve tek taraflı yük taşıma alışkanlığı olanlar bu uygulamayı sıklıkla tercih ediyor. Belirli bir bölgede süregelen ağrınız varsa önce bir hekime görünmenizi rica ediyoruz; hekim onayı varsa medikal masaj planlaması buna göre yapılır.",
        ],
        list: [
          "Boyun ve omuz üst bölgesinde yoğunluk",
          "Sırt ve kürek kemiği çevresinde sertlik",
          "Bel bölgesinde oturmaya bağlı tutukluk",
          "Duruş alışkanlıklarından kaynaklanan gerginlik",
        ],
      },
      {
        h2: "Seans Öncesi Görüşme Neden Daha Uzun?",
        paragraphs: [
          "Medikal masajda ön görüşme klasik masaja göre biraz daha ayrıntılıdır. Gerginliğin nerede olduğunu, ne zamandır sürdüğünü, gün içinde nasıl değiştiğini ve bilinen bir sağlık durumunuz olup olmadığını sorarız. Yakın zamanda geçirilmiş bir sakatlık, ameliyat ya da kullanılan ilaçlar varsa mutlaka paylaşmanız gerekir; bazı durumlarda uygulamayı hekim onayı olmadan yapmayız.",
        ],
      },
      {
        h2: "Uygulama Nasıl İlerler?",
        paragraphs: [
          "Genel bir ısındırmayla başlanır; ardından hedef bölgeye geçilir. Baskı kademeli olarak artırılır ve sizin geri bildiriminizle sınırlanır. Amaç acı vermek değil, \"iyi gelen\" derinliği bulmaktır. Bazı noktalarda birkaç saniye sabit baskı uygulanabilir. Seansın sonunda bölge yeniden yumuşak hareketlerle sakinleştirilir. Medikal masaj Bursa'da tekniğe hâkim, ölçülü bir yaklaşımla uygulanmalıdır; bizim ilkemiz de budur.",
        ],
      },
      {
        h2: "Seans Sonrası ve Beklentiler",
        paragraphs: [
          "Çalışılan bölgede bir iki gün hafif hassasiyet olabilir; bu beklenen bir durumdur. Bol su içmek ve o gün ağır yük taşımamak iyi gelir. Tek seansta kalıcı bir değişim beklenmemeli; birçok misafirimiz düzenli aralıklarla gelmeyi tercih ediyor. Şikâyetiniz artıyorsa ya da değişiyorsa lütfen hekiminize başvurun.",
        ],
      },
      {
        h2: "Nilüfer'de Medikal Masaj Randevusu",
        paragraphs: [
          "Konak Mahallesi'ndeki salonumuzda medikal masaj için WhatsApp'tan yazarken şikâyetinizin bölgesini kısaca belirtmeniz planlamayı kolaylaştırır. Genel rahatlama arıyorsanız klasik masaj, daha hafif bir dokunuş istiyorsanız soft masaj sayfalarımıza göz atabilirsiniz.",
        ],
      },
      {
        h2: "Seanslar Arasında: Günlük Hayatta Küçük Değişiklikler",
        paragraphs: [
          "Medikal masajın etkisini uzatan şey çoğu zaman masaj odasının dışında olur. Ekran yüksekliğini göz hizasına getirmek, telefona bakarken başı öne eğmek yerine cihazı yukarı kaldırmak ve her saat başı bir dakikalık kısa bir yürüyüş yapmak boyun ve omuz yükünü azaltır. Çantayı hep aynı omuzda taşımamak, araç koltuğunu bel desteğiyle ayarlamak da fark yaratır.",
          "Bunlar tıbbi öneri değil, günlük ergonomi hatırlatmalarıdır. Bir şikâyetiniz sürüyorsa hekiminizin önerdiği egzersizler önceliklidir; masaj yalnızca bu sürece rahatlama katkısı sağlayabilir. Seans sırasında gerginliğin toplandığı yerleri sizinle paylaşırız; böylece gün içinde hangi alışkanlığın onu beslediğini fark etmeniz kolaylaşır.",
        ],
        list: [
          "Ekran göz hizasında, telefon yukarıda",
          "Saatte bir kısa hareket molası",
          "Tek omuzda çanta taşımaktan kaçınma",
        ],
      },
    ],
    related: [
      { label: "Klasik Masaj Bursa", path: "/bursa-klasik-masaj" },
      { label: "Soft Masaj Bursa", path: "/bursa-soft-masaj" },
      { label: "Nilüfer'de Masaj Seçimi", path: "/nilufer-masaj" },
      { label: "Bursa Masaj Salonu", path: "/bursa-masaj-salonu" },
      { label: "Masaj Hizmetleri", path: "/masaj-hizmetleri" },
    ],
    faq: [
      { q: "Medikal masaj bel fıtığını tedavi eder mi?", a: "Hayır. Masaj tıbbi bir tedavi değildir. Fıtık gibi tanı konmuş durumlarda hekiminizin onayı olmadan uygulama yapmıyoruz." },
      { q: "Medikal masaj acıtır mı?", a: "Derin çalışılan noktalarda belirgin bir baskı hissedilir ancak acı hedeflenmez. Fazla geldiğinde söylemeniz yeterli, anında hafifletilir." },
      { q: "Sadece boyun bölgesine medikal masaj alabilir miyim?", a: "Evet, uygulama tek bölgeye odaklanabilir. Randevu alırken bunu belirtmeniz süre planlaması için yeterlidir." },
      { q: "Medikal masaj öncesi doktora gitmem gerekir mi?", a: "Süregelen ağrı, yeni bir sakatlık ya da bilinen bir sağlık durumunuz varsa evet. Genel gerginlik için gerekmez ama tereddüt ediyorsanız hekime danışmak en doğrusudur." },
      { q: "Medikal masajdan sonra ağrım artarsa ne yapmalıyım?", a: "Birkaç saat süren hafif hassasiyet normaldir. Ağrı belirgin şekilde artar ya da yayılırsa hekiminize başvurun ve bizi de bilgilendirin." },
      { q: "Hamilelikte medikal masaj yapılır mı?", a: "Hekim onayı olmadan yapmıyoruz. Onay varsa uygun pozisyon ve düşük baskıyla farklı bir planlama yapılır." },
    ],
  },
  {
    path: "/bursa-soft-masaj",
    crumb: "Soft Masaj Bursa",
    title: "Soft Masaj Bursa | Lavenza Nilüfer",
    description: "Bursa soft masaj: hafif dokunuş ve yavaş ritimle derin gevşeme. Hassas ciltler, ilk kez gelenler ve güçlü baskı istemeyenler için. Lavenza Nilüfer Konak, WhatsApp.",
    eyebrow: "Hizmet · Soft Masaj",
    accent: "Bursa",
    h1: "Soft Masaj",
    image: "/images/nilufer-soft-masaj.webp",
    imageAlt: "Soft masaj için mumlar, taşlar ve havlularla sakin ortam",
    service: "Soft Masaj",
    intro: "Her rahatlama güçlü baskı gerektirmez. Soft masaj, hafif dokunuşların ve yavaş bir ritmin bedeni ve zihni birlikte yavaşlattığı nazik bir uygulamadır. Bursa'da soft masaj arayan misafirlerimiz için Lavenza, bu uygulamayı sakinliğin merkeze alındığı bir odada sunar.",
    sections: [
      {
        h2: "Soft Masaj Nasıl Bir Uygulama?",
        paragraphs: [
          "Soft masajda baskı düşük, hareketler uzun ve akıcıdır. Kasları derinden çalışmak yerine sinir sistemini yatıştırmayı hedefler. Ilık yağ, düşük ışık ve yavaş tempo bir araya geldiğinde beden \"tehlike yok\" mesajını alır ve gevşer. Soft masaj Bursa'da genellikle rahatlama masajı olarak da adlandırılır; teknik olarak klasik masajın hafifletilmiş bir yorumudur.",
        ],
      },
      {
        h2: "Kimler İçin İdeal?",
        paragraphs: [
          "Hassas cildi olanlar, kolay morarabilenler, güçlü dokunuştan rahatsız olanlar ve daha önce hiç masaj yaptırmamış kişiler için en güvenli başlangıçtır. Zihinsel yorgunluk fiziksel yorgunluktan ağır basıyorsa, yani \"kaslarım değil kafam yorgun\" diyorsanız soft masaj tam size göre. Uykuya dalmakta zorlanan misafirlerimiz de bu uygulamayı sıklıkla tercih ediyor.",
        ],
        list: [
          "Hassas cilt ve düşük baskı tercihi",
          "İlk masaj deneyimi",
          "Zihinsel yorgunluk ve stres",
          "Uyku öncesi gevşeme isteği",
        ],
      },
      {
        h2: "Seansta Neler Olur?",
        paragraphs: [
          "Kısa bir görüşmenin ardından odada hazırlanırsınız. Uygulama sırt, omuz ve boyunla başlar; kollar, bacaklar ve isteğe bağlı olarak baş bölgesiyle devam eder. Hareketler hiçbir zaman ani ya da sert değildir. Birçok misafirimiz seansın ortasında uyuyakalır; bu, uygulamanın amacına ulaştığının en iyi işaretidir. Seans boyunca konuşmak zorunda değilsiniz.",
        ],
      },
      {
        h2: "Soft Masaj ile Klasik Masaj Farkı",
        paragraphs: [
          "İkisi de tüm vücuda uygulanır ama klasik masaj orta baskıyla kasları yoğururken soft masaj yüzeyde kalır ve ritme odaklanır. Kaslarda belirgin bir sertlik varsa klasik ya da medikal masaj daha etkili olabilir. Amaç yalnızca sakinleşmek ve dinlenmekse soft masaj yeterlidir. Kararsız kaldığınızda soft masajla başlayıp bir sonraki seansta baskıyı artırmak iyi bir yoldur.",
        ],
      },
      {
        h2: "Kese & Köpükle Birlikte",
        paragraphs: [
          "Soft masaj, kese ve köpük ritüelinin ardından alındığında bütünsel bir spa akışına dönüşür: önce cilt yenilenir, ardından beden nazikçe gevşetilir. Nilüfer spa arayan misafirlerimizin en sık tercih ettiği kombinasyon budur.",
        ],
      },
      {
        h2: "Nilüfer'de Soft Masaj Randevusu",
        paragraphs: [
          "Konak Mahallesi'ndeki salonumuzda soft masaj için WhatsApp'tan yazmanız yeterli; \"hafif baskı istiyorum\" notu eklemeniz ekibimizin planlamasını kolaylaştırır. Soft masaj Nilüfer'de ilk kez masaja gelecekler için hazırladığımız rehbere de göz atabilirsiniz.",
          "Seansı akşam saatlerine koymak, soft masajın sakinleştirici etkisini uykuya taşımanın en iyi yoludur. Gece geç saatlere kadar açık olmamız sayesinde yatmadan bir iki saat önce bir randevu planlamak mümkündür.",
        ],
      },
      {
        h2: "Odadaki Atmosfer: Işık, Ses ve Koku",
        paragraphs: [
          "Soft masajda teknik kadar ortam da önemlidir, çünkü hedef sinir sistemini yatıştırmaktır. Işık, gözleri yormayacak kadar loş tutulur; doğrudan yüzünüze vuran hiçbir kaynak olmaz. Müzik, ritmi fark edilmeyecek kadar yavaş ve düşük seste çalar; isterseniz tamamen kapatılır. Kokuda tercih sizin: hafif bir lavanta notası ya da hiç koku olmaması.",
          "Odanın sıcaklığı seans öncesinde ayarlanır; üşümek gevşemenin en büyük düşmanıdır, bu yüzden üzerinizdeki örtü sıcak tutulur. Dış sesleri azaltmak için kapı kapalı, telefonlar sessizdedir. Tüm bu ayrıntılar, soft masajın hafif dokunuşlarının bedeninizde derin bir karşılık bulmasını sağlar.",
        ],
        list: [
          "Loş, dolaylı aydınlatma",
          "Düşük sesli veya tamamen kapalı müzik",
          "Tercihe göre hafif koku ya da kokusuz ortam",
          "Sıcak tutulan örtü ve ayarlanmış oda ısısı",
        ],
      },
    ],
    related: [
      { label: "Klasik Masaj Bursa", path: "/bursa-klasik-masaj" },
      { label: "Medikal Masaj Bursa", path: "/bursa-medikal-masaj" },
      { label: "Konak'ta İlk Seans Rehberi", path: "/konak-masaj" },
      { label: "Nilüfer Spa Merkezi", path: "/nilufer-spa" },
      { label: "Masaj Hizmetleri", path: "/masaj-hizmetleri" },
    ],
    faq: [
      { q: "Soft masaj etkili olur mu, çok hafif kalmaz mı?", a: "Amaç kasları derinden çalışmak değil, sinir sistemini yatıştırmaktır. Zihinsel yorgunluk ve stres için çoğu misafirimiz belirgin bir rahatlama tarif ediyor." },
      { q: "Soft masajda uyuyakalmak normal mi?", a: "Evet, oldukça sık görülür ve uygulamanın işe yaradığını gösterir. Seans sonunda nazikçe uyandırılırsınız." },
      { q: "Hassas cildim var, hangi yağ kullanılıyor?", a: "Cilt dostu, hafif masaj yağları kullanıyoruz. Bilinen bir alerjiniz varsa seans öncesinde belirtmeniz yeterli." },
      { q: "Soft masaj çocuklar veya yaşlılar için uygun mu?", a: "Düşük baskı nedeniyle genellikle uygundur, ancak sağlık durumuna göre hekim görüşü almanızı öneririz. Randevu alırken bilgi verin." },
      { q: "Soft masajı baş masajıyla birleştirebilir miyim?", a: "Evet, seans öncesinde belirtirseniz baş ve yüz bölgesi de uygulamaya dahil edilebilir. Baş masajı özellikle zihinsel yorgunluk ve uyku öncesi gevşeme için soft masajı güzel tamamlar." },
    ],
  },
];
